import React from 'react';
import Icon from './Icon';

const ForSaleIcon = (props) => (
    <Icon {...props}>
        <path
            d="M10 7H14.5C15.88 7 17 8.12 17 9.5C17 10.88 15.88 12 14.5 12H10V18M8 12H13M8 15H13M9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ForSaleIcon;
